/**
 * PremiumGate — Blocks premium content for non-subscribers
 * Port of premium-gate.component from Ionic app
 */
import { useMonetization } from '../services/monetization';
import { Link } from 'react-router-dom';

const PremiumGate = ({ feature, children, title }) => {
  const { hasFeature, isPremium } = useMonetization();

  if (hasFeature(feature) || isPremium) {
    return children;
  }

  return (
    <div style={{ textAlign: 'center', padding: '40px 20px', backgroundColor: '#fff8e1', borderRadius: '16px', margin: '16px', border: '2px solid #f9a825' }}>
      <div style={{ fontSize: '3rem', marginBottom: '12px' }}>🔒</div>
      <h3 style={{ color: '#e65100', fontWeight: 800, fontSize: '1.2rem', marginBottom: '8px' }}>
        {title || 'Premium வசதி'}
      </h3>
      <p style={{ color: '#5d4037', fontSize: '0.9rem', marginBottom: '16px', lineHeight: 1.5 }}>
        இந்த வசதி Premium சந்தாதாரர்களுக்கு மட்டும். <br/>
        Premium உறுப்பினராகி அனைத்து வசதிகளையும் பெறுங்கள்!
      </p>
      <Link to="/premium-store" style={{
        display: 'inline-block', padding: '12px 24px', backgroundColor: '#0a0e27',
        color: '#f0d48a', borderRadius: '24px', fontWeight: 700, fontSize: '1rem',
        textDecoration: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
      }}>
        ⭐ Premium Store →
      </Link>
    </div>
  );
};

export default PremiumGate;
